import { get as i, isFunction as f } from "../index.js";
import { camelize as u } from "../format/string.js";
import c from "../../locale/index.js";
function l(n) {
  var s = u(n) + ".";
  return function (t) {
    for (var a = c.messages(), e = i(a, s + t) || i(a, t), o = arguments.length, m = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++) m[r - 1] = arguments[r];
    return f(e) ? e.apply(void 0, m) : e;
  };
}
export { l as createI18N };
